// full details here:
// https://git.hubteam.com/HubSpot/crm-datasets-ui/issues/2#issuecomment-1701810
export const READ_ONLY = 'READ_ONLY'; // +view -edit

export const NOT_SPECIFIED = 'NOT_SPECIFIED'; // +view +edit

export const HIDDEN = 'HIDDEN'; // -view -edit